import React from 'react';

export const WorksDisplayContext = React.createContext({});